export default "/packs/images/level-cover~fcf7e7d83e8538da24a111ca967078d5.png";